import { storeToRefs } from 'pinia'

export default defineNuxtRouteMiddleware((to) => {
  const { authenticated, driverId } = storeToRefs(useAuthStore()) // make authenticated state reactive
  const token = useCookie('token_refresh')

  // TODO: Сделать проверку на протухание токена, и если протух - чистить хранилище.

  if (token.value && driverId.value) {
    authenticated.value = true // update the state to authenticated
  } else {
    authenticated.value = false
  }

  // if token exists and url is /login redirect to homepage
  if (authenticated.value && to?.name === 'login') {
    return navigateTo('/')
  }

  if (authenticated.value && to?.name === 'code') {
    return navigateTo('/')
  }

  // if token doesn't exist redirect to log in
  if (!authenticated.value && to?.name !== 'login' && to?.name !== 'login-code' && to?.name !== 'login-call') {
    abortNavigation()
    return navigateTo('/login')
  }
})
